<template>
  <div class="container">
    <navComponent />
    <div class="bgcImg"></div>
    <div class="contentBox">
      <div class="zhengwen">
        <div class="biaoti">{{ title }}</div>
        <div class="time">{{ time }}</div>
        <van-divider />
        <div v-html="content" class="neirong"></div>
        <div class="inner-img" v-if="val === '7'">
          <img :src="imgUrl" alt="" />
          <img :src="imgUrl2" alt="" />
          <img :src="imgUrl3" alt="" />
          <div v-html="content1" class="neirong"></div>
        </div>
        <div class="inner-img" v-if="val === '8'">
          <img :src="imgUrl" alt="" />
          <div v-html="content1" class="neirong"></div>
        </div>
        <div class="inner-img" v-if="val === '10'">
          <img :src="imgUrl" alt="" />
          <div v-html="tip" class="neirong tip-style"></div>
          <div v-html="content1" class="neirong"></div>
        </div>
        <div class="inner-img" v-if="val === '11'">
          <img :src="imgUrl" alt="" />
          <img :src="imgUrl2" alt="" />
          <div v-html="content1" class="neirong"></div>
        </div>
      </div>
    </div>
    <footerComponent />
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tip: '',
        title: '',
        time: '',
        content: '',
        contentData: [
          {
            title: '众腾信安发布大数据架构的日志审计分析平台',
            time: '2021-08-01',
            content:
              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;                  2021年8月，众腾信安正式发布基于大数据架构的日志审计分析平台，新系统具有如下特色优势：<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1、完善的资产管理机制：具有详细的资产地图、资产分组、资产标签等资产管理机制，让IT资产一目了然。是业界资产管理能力最全面的日志产品之一。 <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2、强大的日志源管理能力：不仅支持全面的日志采集、日志源拆分、合并及分组等管理方式，还支持独创的日志源主动发现能力。对市场常见的IT设备（如网络、安全、OS…），基本已支持兼容。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3、解析规则自定制：内置数千条解析规则集。同时还提供图形化规则编写工具，将可理解的自然语言轻松转换成机器理解的解析规则，大大提升了产品部署的兼容性和便捷性。是业界极少数内置规则集且提供自定制工具的日志厂商。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4、高级日志分析能力：不仅支持传统的日志关联分析，内置大量常用的安全规则集，还支持深度树解析，支持JSON，GROK等多种模式的嵌套解析，实现深度智能分析，大大提升客户安全分析能力。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5、功能丰富：除支持日志采集及分析外，还支持资产性能监控、故障监控、安全基线核查等智能运维功能。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6、部署能力强：不仅支持软硬件一体化部署，还支持纯软件方式部署，软件支持虚拟化和容器部署。是业界极少数支持容器部署的日志厂商。',
          },
          // {
          //   title: '众腾信安发布堡垒机产品',
          //   content: '&nbsp;&nbsp;&nbsp;&nbsp;2021年8月，众腾信安正式发布运维安全管理平台（又称为堡垒机），是一款集账号管理、身份认证、单点登录、资源授权、访问控制和操作审计为一体的新一代运维安全管理产品。<br>&nbsp;&nbsp;&nbsp;&nbsp;产品实现对网络设备、数据库、安全设备、主机系统等资源的统一运维管理和审计，并通过集中化运维管控、运维过程实时监管、运维访问合规性控制、运维过程图形化审计等功能，构建了一套事前预防、事中监控、事后审计完善的安全管理体系，广泛满足政府、金融、能源、电力、教育、医疗、央企等各行业客户的运维审计规范要求。<br>&nbsp;&nbsp;&nbsp;&nbsp;产品特点：<br>&nbsp;&nbsp;&nbsp;&nbsp;1、全面平台支持：对各类型服务器、安全设备、网络设备、存储设备及中间件等资产全面兼容，支持各种协议的运维操作审计。<br>&nbsp;&nbsp;&nbsp;&nbsp;2、完备的审计报表：提供丰富的审计报表，多维度可视化，能帮客户快速定位责任鉴定及事件追溯。<br>&nbsp;&nbsp;&nbsp;&nbsp;3、灵活的认证机制：提供近10种强认证机制（证书、动态口令、KEY、短信验证、手机令牌等），可实现双因子组合认证，并采用了联动微信小程序令牌的动态认证机制。<br>&nbsp;&nbsp;&nbsp;&nbsp;4、支持自动改密：提供了完善的自动改密功能，支持自定义口令变更周期、口令强度以及多种口令变更方式。<br>&nbsp;&nbsp;&nbsp;&nbsp;5、采用多种新技术：支持自动化运维、双人协同、运维流程管理、应用发布服务器支持国产化平台及运维水印等功能，既保证运维的安全性，又提高了运维效率。<br>&nbsp;&nbsp;&nbsp;&nbsp;'
          // },
          {
            title: '众腾信安日志审计分析平台助力杭州交投集团',
            time: '2021-10-25',
            content:
              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 杭州市交通投资集团有限公司（简称“杭州交投集团”），是杭州市政府直接领导并授权经营的国有独资企业，主要承担杭州市交通基础设施的投资、建设和营运主平台的职能。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 近日，我司日志审计分析平台中标杭州交投集团，并已顺利部署实施运行，实现了对内网中的设备、服务器、网络系统等资产进行日志的采集、解析、关联分析以及存储和检索，能够精准定位安全事件，进行溯源追踪和及时取证处理，降低了信息系统的整体安全风险，满足了杭州交投集团信息安全管理的需求。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
          },
          {
            title: '众腾信安日志审计分析平台助力浙江高速',
            time: '2021-12-04',
            content:
              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 在浙江某高速收费系统、监控系统等保安全加固改造项目中，我司日志审计分析平台顺利中标，并已部署实施稳定运行。这是我司在轨道交通行业的又一成功突破。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 高速公路数字化、智慧化的业务发展方向，可解决路网高效运行、及时处置突发事件和为广大群众提供优质出行服务等需要，有助于打造新型数字化城市、实现交通强国战略。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 在智慧交通的未来之路上，众腾信安将秉承“让数据创造最大业务价值”的愿景，以等保合规为基本原则，助力我国高速公路构建安全的智慧高速网络。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
          },
          {
            title: '众腾信安与龙芯中科完成产品兼容互认证明',
            time: '2022-01-10',
            content:
              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“芯”起点，“创”未来！<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 近日，杭州众腾信安科技有限公司的众腾信安日志审计分析平台V1.0顺利完成与龙芯3A4000/3B4000、3A5000/3B5000的兼容性测试。在测试过程中，功能、性能与兼容性等方面均表现良好，且系统整体运行稳定，已获得龙芯中科技术股份有限公司“龙芯架构兼容互认证书”及“产品兼容互认证明”。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 信息技术应用创新是新时代信息技术发展的重要趋势，产品兼容适配是信息技术应用创新的重要手段。此次兼容认证的众腾信安日志审计分析平台，采用先进的大数据采集、建模、分析技术，支持对各种IT资源进行日志采集，配合智能高级分析，及时发现网络当中的威胁和异常行为，提供了从数据的采集、存储、搜索、展示，到安全分析及运维等一系列服务，满足等保合规性的同时，帮助客户快速做出判断和决策，大大提升运维效率。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;完善的兼容性是信创产业得以持续向好发展的重要前提，此次产品的兼容互认证为双方生态合作打造了坚实的基础。未来，众腾信安将积极与广大产业伙伴推进产品生态合作，为信创事业和数字化转型，提供更有力的安全保障。我们也将继续以数据为中心，以网络安全和智能运维为驱动，让数据为客户创造最大业务价值。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
          },
          // {
          //   title: '全面支持国产化，安科众腾与麒麟软件完成产品兼容互认证明',
          //   content: '&nbsp;&nbsp;&nbsp;&nbsp;近日，杭州安科众腾科技有限公司（以下简称“安科众腾”）与麒麟软件有限公司(以下简称“麒麟软件”) 完成兼容性互认证。安科众腾自主研发的日志审计分析平台，与银河麒麟高级服务器操作系统（龙芯版）V10、银河麒麟桌面操作系统（龙芯版）V10顺利完成兼容性测试，测试结果达到通用兼容性要求，展现出高性能、功能丰富、安全稳定，满足各行业客户对国产操作系统及日志审计分析的需求。<br>&nbsp;&nbsp;&nbsp;&nbsp;此次兼容性互认证，表明安科众腾日志审计分析平台可以在银河麒麟操作系统之上安全、稳定、高效的运行，同时也意味着安科众腾获得了更全面的国产化适配支持，国产化生态版图进一步扩大。未来，双方将会进一步拓宽合作范围，携手推进国产化操作系统和网络安全建设在千行百业的深度落地。<br>&nbsp;&nbsp;&nbsp;&nbsp;安科众腾日志审计分析平台，采用先进的大数据采集、建模、分析技术，支持对各种IT资源进行日志采集，配合智能高级分析，及时发现网络当中的威胁和异常行为，提供了从数据的采集、存储、搜索、展示，到安全分析及智能运维等一系列服务，在满足等保合规性要求的同时，帮助客户在安全风险和设备故障发生时快速做出决策和响应，大大提升运维效率。目前产品已在全国各行业客户中规模应用和部署。<br>&nbsp;&nbsp;&nbsp;&nbsp;安科众腾作为一家具备国产自主知识产权的高科技企业，始终致力于为关键行业数字化转型和信息产业国产化发展贡献力量。'
          // }
          // 修改
          {
            title: '众腾信安完成统信UOS操作系统产品互认测试',
            time: '2022-02-20',
            content:
              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日前，众腾信安日志审计分析平台V1.0顺利完成与统信软件桌面操作系统和服务器操作系统V20的兼容性测试。标志着众腾信安日志审计分析平台在通用兼容性及功能性、可靠性适配方面均符合要求，满足用户的关键性应用需求且整体系统功能正常、运行稳定。',
            imgUrl: require('../../../news/assets/img/1-1.jpeg'),
            imgUrl2: require('../../../news/assets/img/1-2.jpeg'),
            imgUrl3: require('../../../news/assets/img/1-3.jpeg'),
            content1:
              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;随着国产化进程的推进，国产系统作为保障国家网络安全的重要组成部分，具有安全、自主、可控等突出优势。众腾信安作为国内专业的数据分析和解决方案提供商，一向以高可靠性的产品特性和完善的技术服务体系而备受客户认可。先后在交通、医疗、公共事业等行业服务了众多标杆客户。此次产品兼容性认证为广大国产操作系统用户解决安装部署难等难题，向全面支持国产化又迈出了关键一步。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在国产化兼容适配性方面，众腾信安日志审计分析平台支持龙芯等国产主流处理器，以及麒麟等国产主流操作系统，本次众腾信安与统信软件完成互认证，也进一步展示了国产信息化生态系统的协同发展已日臻完善，我们也将积土为山，积水为海，不断完善产品和解决方案，给用户带来更可靠的服务。',
          },
          {
            title: '众腾信安与海光完成产品兼容互认证明',
            time: '2022-04-15',
            imgUrl: require('../../../news/assets/img/3-1.png'),
            content:
              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日前，众腾信安日志审计分析平台与中科可控海光完成了产品兼容性的相互认证。经众腾信安与中科可控的联合测试，众腾信安日志审计分析平台与基于国产海光处理器的中科可控R系列服务器兼容性良好，可以顺利安装、配置，并稳定运行。',
            content1:
              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;新一代信息技术是国务院确定的七个战略性新兴产业之一，也是当今形势下国内经济发展的新动能。随着国家信息产业转型升级陆续推进，全面国产化替代进程也正在不断提速发展，众腾信安日志审计分析平台此前已全面适配银河麒麟、统信软件等国产软硬件操作系统，此次众腾信安日志审计分析平台与海光系列处理器兼容认证的顺利实现，标志着众腾信安在国产化生态领域的又迈出了坚实的一步，这也表明众腾信安日志审计分析平台具有高性能、高兼容性、高可靠性的特点。未来，双方在不断完善自身能力的同时，将继续深化合作，开拓国产化产品及市场，共同推广产品及解决方案，为用户构建更稳定、更安全信息环境。',
          },
          {
            title: '众腾信安喜获浙江省科技型中小企业认定',
            time: '2022-05-10',
            content:
              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;近日，杭州众腾信安科技有限公司入选科技型中小企业名单。科技型中小企业，表明企业依托技术人员从事技术研究开发活动，取得自主知识产权并将其转化为高新技术产品或服务，从而实现可持续发展。这次入选，是对众腾信安持续技术研发投入，创新技术服务能力的激励和肯定。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未来，我们将不忘初心、牢记使命、创新发展，紧跟科技发展的步伐，持续在技术领域进行重点投入与不断创新，持续为更多客户提供高质量的产品、服务与方案，助力国家数字科技赋能经济发展。',
          },
          {
            title: '众腾信安入选2022年安全牛《中国网络安全行业全景图（第九版）》',
            time: '2022-03-31',
            imgUrl: require('../../../news/assets/img/2-1.png'),
            tip: '来源：《中国网络安全行业全景图（2022年3月第九版）》',
            content:
              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2022年3月31日，安全牛《中国网络安全行业全景图（第九版）》正式发布。第九版全景图研究属于安全牛年度性《中国网络安全产业核心洞察报告》的产品篇，有500家企业进行申请，但全景图对报告收录有严格考评要求，主要包括以下两方面：<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;产品可实际交付，具备较好的应用性和技术特点；<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;产品有较成熟的市场应用，在领域中有一定市场份额占比。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;此次，杭州众腾信安科技有限公司（以下简称“众腾信安”）突围而出，成为安全管理与运营领域的代表企业，也是入选名单中最年轻的科技公司，这一进步对我们而言来之不易。',
            content1:
              '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;众腾信安自2021年成立以来，一直秉承“做有用的产品、好用的产品”为核心理念，凭借优异的技术领先性和卓越的服务质量，获得了客户和合作伙伴的广泛认可。目前，产品已规模部署于杭州交投、浙江高速、盐城超算中心等高端客户。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未来，我们将再接再厉，在加大研发投入的同时，坚持技术创新与行业布局，致力于为客户提供完整的机器数据分析解决方案，为客户创造最大业务价值！',
          },
          {
            title: '国产化再进一步！众腾信安通过麒麟软件适配测试',
            time: '2022-06-15',
            imgUrl: require('../../../news/assets/img/4-1.jpeg'),
            imgUrl2: require('../../../news/assets/img/4-1.jpeg'),
            content:
              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;近日，杭州众腾信安科技有限公司的众腾信安日志审计分析平台V1.0顺利完成与麒麟桌面操作系统和服务器操作系统V10的兼容性测试。测试结果表明，众腾信安日志审计分析平台V1.0具备高稳定性，高兼容性及可靠性，能在国产设备和系统平台上稳定运行，已获得麒麟软件有限公司“产品兼容互认证明”。',
            content1:
              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;信息技术应用创新是新时代信息技术发展的重要趋势，产品兼容适配是信息技术应用创新的重要手段。此次兼容认证的众腾信安日志审计分析平台，采用先进的大数据采集、建模、分析技术，支持对各种IT资源进行日志采集，配合智能高级分析，及时发现网络当中的威胁和异常行为，提供了从数据的采集、存储、搜索、展示，到安全分析及运维等一系列服务，满足等保合规性的同时，帮助客户快速做出判断和决策，大大提升运维效率。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;目前除了与麒麟软件外，已完成了与龙芯等国产主流系统的适配互认证。本次与麒麟软件完成产品兼容性互认证，也意味着众腾信安获得了更全面的国产化适配支持，国产化生态版图进一步扩大。我们也将继续以数据为中心，以网络安全和智能运维为驱动，让数据为客户创造最大业务价值。',
          },
        ],
        val: this.$route.params.Id,
      };
    },
    created() {
      if (this.val === '1') {
        this.title = this.contentData[0].title;
        this.time = this.contentData[0].time;
        this.content = this.contentData[0].content;
      }
      // if (val === '2') {
      //   this.title = this.contentData[1].title
      //   this.content = this.contentData[1].content
      // }
      if (this.val === '3') {
        this.title = this.contentData[1].title;
        this.time = this.contentData[1].time;
        this.content = this.contentData[1].content;
      }
      if (this.val === '4') {
        this.title = this.contentData[2].title;
        this.time = this.contentData[2].time;
        this.content = this.contentData[2].content;
      }
      if (this.val === '5') {
        this.title = this.contentData[3].title;
        this.time = this.contentData[3].time;
        this.content = this.contentData[3].content;
      }
      // if (val === '6') {
      //   this.title = this.contentData[5].title
      //   this.content = this.contentData[5].content
      // }
      if (this.val === '7') {
        this.title = this.contentData[4].title;
        this.time = this.contentData[4].time;
        this.content = this.contentData[4].content;
        this.imgUrl = this.contentData[4].imgUrl;
        this.imgUrl2 = this.contentData[4].imgUrl2;
        this.imgUrl3 = this.contentData[4].imgUrl3;
        this.content1 = this.contentData[4].content1;
      }
      if (this.val === '8') {
        this.title = this.contentData[5].title;
        this.time = this.contentData[5].time;
        this.content = this.contentData[5].content;
        this.imgUrl = this.contentData[5].imgUrl;
        this.content1 = this.contentData[5].content1;
      }
      if (this.val === '9') {
        this.title = this.contentData[6].title;
        this.time = this.contentData[6].time;
        this.content = this.contentData[6].content;
      }
      if (this.val === '10') {
        this.title = this.contentData[7].title;
        this.time = this.contentData[7].time;
        this.content = this.contentData[7].content;
        this.imgUrl = this.contentData[7].imgUrl;
        this.content1 = this.contentData[7].content1;
        this.tip = this.contentData[7].tip;
      }
      if (this.val === '11') {
        this.title = this.contentData[8].title;
        this.time = this.contentData[8].time;
        this.content = this.contentData[8].content;
        this.imgUrl = this.contentData[8].imgUrl;
        this.imgUrl2 = this.contentData[8].imgUrl2;
        this.content1 = this.contentData[8].content1;
      }
    },
  };
</script>

<style lang="css" scoped>
  .bgcImg {
    margin-top: 46px;
    width: 100%;
    text-align: center;
    color: #fff;
    height: 100px;
    background: url(../../asset/home4.png) top center no-repeat;
    background-size: contain;
  }
  .title1 {
    padding: 20% 0 5% 0;
    font-size: 18px;
    font-family: 'Alibaba-PuHuiTi-M, Alibaba-PuHuiTi';
    font-weight: normal;
    line-height: 13px;
  }
  .title2 {
    font-size: 8px;
    font-family: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi';
  }

  .contentBox {
    margin-bottom: 60px;
    height: 100%;
    padding: 0 7%;
    background-color: #fff;
  }
  .contentTitle {
    text-align: center;
  }
  .world1 {
    padding: 30px 0 10px 0;
    font-size: 24px;
    font-family: 'Alibaba-PuHuiTi-M, Alibaba-PuHuiTi';
    font-weight: normal;
    color: rgba(31, 33, 38, 0.7);
    line-height: 33px;
  }
  .world2 {
    font-size: 12px;
    font-family: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi';
    font-weight: normal;
    color: rgba(0, 0, 0, 0.5);
    line-height: 18px;
  }
  .contentBoxIner {
    text-align: left;
    padding-top: 50px;
  }
  .boxL {
    height: 70px;
  }
  .boxR {
    height: 70px;
    margin-top: 38px;
  }
  .picText {
    font-size: 16px;
    font-family: 'Alibaba-PuHuiTi-M, Alibaba-PuHuiTi';
    font-weight: normal;
    color: rgba(0, 0, 0, 0.8);
    line-height: 30px;
  }
  .picContent {
    font-size: 12px;
    font-family: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi';
    font-weight: normal;
    color: rgba(0, 0, 0, 0.4);
    line-height: 20px;
  }

  .contentBox2 {
    padding: 0 7%;
    background: rgba(0, 180, 243, 0.03);
  }
  .contentBox3 {
    padding: 0 7%;
    margin-bottom: 58px;
  }
  .biaoti {
    text-align: center;
    margin: 30px 0 10px 0;
    font-size: 16px;
    font-family: 'Alibaba-PuHuiTi-B, Alibaba-PuHuiTi';
    font-weight: normal;
    color: rgba(31, 33, 38, 0.7);
    line-height: 22px;
  }
  .neirong {
    font-size: 13px;
    font-family: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi';
    font-weight: normal;
    color: rgba(0, 0, 0, 0.5);
    line-height: 22px;
  }
  .zhengwen .tip-style {
    text-align: center;
    font-size:6px;
  }
  .time {
    text-align: center;
    font-size: 13px;
    font-family: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi';
    font-weight: normal;
    color: rgba(0, 0, 0, 0.5);
    line-height: 9px;
  }
  .inner-img {
    width: 100%;
  }
  .inner-img img {
    /* text-align: center; */
    width: 60%;
    margin: 20px 20%;
  }
</style>
